<template>
    <Card class="layout-card" style="height: 100%;">
        <div style="display:flex;justify-content: space-between;margin-bottom: 10px;flex-shrink: 0;">
            <div class="search-form">
                <Input :maxlength="100" v-model="searchForm.role" placeholder="请输入角色英文名" />
                <Input :maxlength="100" v-model="searchForm.roleCn" placeholder="请输入角色中文名" />
                <Button type="primary" v-if="buttonMenu['/role/view']" @click="getData()">查询</Button>
                <Button @click="handleReset()">重置</Button>
            </div>
            <div><Button type="primary" v-if="buttonMenu['/role/add']" @click="handleOpenEditModal()">添加</Button></div>
        </div>
        <div style="height: 100%;overflow:auto">
        <Table :data="tableData" :columns="columns">
            <template #action="{row}">
                <div>
                    <a v-if="buttonMenu['/role/menu']" @click="handleOpenModal(row)">分配菜单</a>
                    <a style="margin-left: 10px;" v-if="buttonMenu['/role/edit']" @click="handleOpenEditModal(row)">编辑</a>
                    <Poptip confirm title="确定要删除吗？" v-if="buttonMenu['/role/delete']" transfer @on-ok="handleDel(row)"><a style="margin-left: 10px;color: red">删除</a></Poptip>
                </div>
            </template>
            <Pages slot="footer" :page="page" :func="getData"></Pages>
        </Table>
        </div>

        <Modal v-model="visible" title="菜单分配" :width="700">
            <!-- <Transfer style="text-align:center;"
            :render-format="(data)=>data.permissionName"
            :data="allPermissions"
            :target-keys="userPermissions"
            @on-change="userPermissions = $event"
             :list-style="{
                width: '400px',height: '520px'
            }"></Transfer> -->
                <Tree style="font-size:14px;"
                ref="treeRef"
                check-strictly
                show-checkbox
                :render="renderContent"
                :data="treeData"
                 @on-check-change="handleSelectTreeNode"></Tree>
            <template #footer>
                <Button @click="visible=false">取消</Button>
                <Button type="primary" :loading="loading" @click="handleSubmitMenu()">提交</Button>
            </template>
        </Modal>
        <Modal v-model="editVisible" :title="form.id?'编辑':'新增'+'角色'">
            <Form @submit.native.prevent :label-width="120" v-if="editVisible" :model="form" ref="formRef">
                <FormItem label="角色英文名称："  :rules="[{required:true,message:'请输入角色英文名称'}]" prop="role">
                    <Input :maxlength="100" v-model="form.role" />
                </FormItem>
                <FormItem label="角色中文名称："  :rules="[{required:true,message:'请输入角色中文名称'}]" prop="roleCn">
                    <Input :maxlength="100" v-model="form.roleCn" />
                </FormItem>
                <!-- <a @click="handleOpenModal(form)">分配权限</a> -->
            </Form>
            <template #footer>
                <Button @click="editVisible=false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
            </template>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getRoleList, addRole, delRole, editRole, getRoleInfo, getRoleMenuTree, addRoleMenuTree } from '@/api/role'
import { cloneDeep } from 'lodash'
export default {
  components: {
    Pages
  },
  data() {
    return {
      visible:false,
      submitLoading:false,
      loading:false,
      editVisible:false,
      searchForm: {},
      form:{},
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      selectTreeNodes: [],
      treeData: [],
      columns: [
        // {
        //   title: 'id',
        //   key: 'id'
        // },
        {
          title: '角色英文名',
          key: 'role'
        },
        {
          title: '角色中文名',
          key: 'roleCn'
        },
        {
          title: '创建人',
          key: 'createUserName'
        },
        {
          title: '创建时间',
          key: 'createTimeFmt'
        },
        {
          title: '修改人',
          key: 'updateUserName'
        },
        {
          title: '修改时间',
          key: 'updateTimeFmt'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ]
    }
  },
  computed:{
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('system/role')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods:{
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getRoleList({
        ...this.page,
        ...this.searchForm
      }).then(({ data }) => {
        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    renderContent(h, { root, node, data }) {
      if (node.node.checked) {
        const row = root.find(el => el.nodeKey === node.parent)
        if (row)row.node.checked = true
      }
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [
        h('span', [
          h('Icon', {
            props: {
              type: 'ios-paper-outline'
            },
            style: {
              marginRight: '8px'
            }
          }),
          h('span', data.menuName)])
      ])
    },
    recursionDown(data, node, action, value) {
      return data.map(el => {
        if (node === el.id || node === 'all') {
          el[action] = value
          el.children = this.recursionDown(el.children, 'all', action, value)
        } else {
          el.children = this.recursionDown(el.children, node, action, value)
        }
        return el
      })
    },
    handleSelectTreeNode(data, row) {
      const action = data.findIndex(el => el.id === row.id) !== -1
      if (!action) {
        this.treeData = this.recursionDown(cloneDeep(this.treeData), row.id, 'checked', action)
      }
      this.selectTreeNodes = data
    },
    async handleOpenModal(row) {
      if (row.id) {
        this.handleGetTree(row.id)
        this.form = row
      }

      this.visible = true
    },
    async handleOpenEditModal(row) {
      if (row) {
        const r = await getRoleInfo(row.id)
        this.form = r.data
      } else {
        this.form = {
        }
      }
      this.editVisible = true
    },
    handleSubmit(type) {
      if (this.$refs.formRef) {
        this.$refs.formRef.validate(r => {
          if (r) {
            const func = this.form.id ? editRole : addRole
            this.submitLoading = true
            const { id, role, roleCn } = this.form
            func({
              id, role, roleCn
            }).then(r => {
              this.$Message.success('操作成功')
              this.getData()
              this.submitLoading = false
              if (!type) { this.editVisible = false }
            }).catch(() => {
              this.submitLoading = false
            })
          }
        })
      } else {
        const func = this.form.id ? editRole : addRole
        this.submitLoading = true
        const { id, role, roleCn } = this.form
        func({
          id, role, roleCn
        }).then(r => {
          this.$Message.success('操作成功')
          this.getData()
          this.submitLoading = false
          if (!type) { this.editVisible = false }
        }).catch(() => {
          this.submitLoading = false
        })
      }
    },
    handleSubmitMenu() {
      if (this.form.id) {
        const nodes = this.$refs.treeRef.getCheckedNodes()
        const params = nodes.map(i => ({
          menuId: i.id,
          roleId: this.form.id
        }))
        this.loading = true
        addRoleMenuTree(params).then(r => {
          this.$Message.success('操作成功')
          this.visible = false
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.visible = false
        })
      }
    },
    handleDel(row) {
      delRole(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
    },
    handleGetTree(id) {
      this.treeData = []
      getRoleMenuTree(id).then(r => {
        this.treeData = r.data
      })
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="less">
.search-form{
    display:flex;
    &>*{
        margin: 0 5px;
    }
}
/deep/.ivu-transfer-list-content-item{
  text-align: left;
}
.layout-card{
  /deep/ &>.ivu-card-body{
    height: 100%;display:flex;flex-direction: column;
  }
}
</style>
